import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { api } from "../../config";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchComAuth } from "../../common/api";

const ModalAlterarSenha = ({ isOpen, onClose, onSave, usuario, loading }) => {
    const [senhaShow, setSenhaShow] = useState(false);
    const [confirmarSenhaShow, setConfirmarSenhaShow] = useState(false); 
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
        senha: "",
        confirmar_senha: "",
        },
        validationSchema: Yup.object({
        senha: Yup.string()
            .required("Senha é obrigatória")
            .test(
            "min-length",
            "A senha precisa ter no mínimo 6 caracteres válidos",
            (value) => value && value.trim().length >= 6
            ),
        confirmar_senha: Yup.string()
            .required("Confirmação de senha é obrigatória")
            .oneOf([Yup.ref("senha")], "As senhas devem ser iguais"),
        }),
        onSubmit: async (values) => {
            
            try {
                const body = {
                    usuario_id: usuario.id,
                    senha: values.senha
                };

                const response = await fetchComAuth(`${api.API_URL}/atualizarSenha`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json', 
                        'Accept': 'application/json'
                    },
                
                });

                if (!response.ok) throw new Error('Erro ao atualizar senha do usuário');

                toast.success("Usuário atualizado com sucesso! A senha foi enviada para o e-mail informado.");
                onClose();
            } catch (error) {
                console.error("Erro ao atualizar o usuário:", error);
                toast.error("Erro ao atualizar o usuário.");
            } finally {
                
            }
    
        },
    });

    useEffect(() => {
        if (isOpen) {
            validation.resetForm();
        }
    }, [isOpen]);

    return (
        
        <Modal isOpen={isOpen} toggle={onClose} centered>
             <ToastContainer closeButton={false} />
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                }}
            >
                <ModalHeader toggle={onClose} className="bg-light p-3">
                    Atualizar Senha de {usuario?.name}
                </ModalHeader>
                <ModalBody>
                
                    <Row>
                        <div className="mb-3">
                            <Label htmlFor="senha">Nova Senha</Label>
                                <div className="position-relative auth-pass-inputgroup">
                                                                        
                                    <Input
                                        type={senhaShow ? "text" : "password"}
                                        id="senha"
                                        name="senha"
                                        placeholder="Informe a nova senha"
                                        value={validation.values.senha}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                        validation.touched.senha && !!validation.errors.senha
                                        }
                                        disabled={loading}
                                    />
                                    <FormFeedback>{validation.errors.senha}</FormFeedback>
                                    <Button color="link" onClick={() => setSenhaShow(!senhaShow)} 
                                        className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                        id="password-addon"><i className="ri-eye-fill align-middle"></i></Button>
                                </div>                           
                        </div>

                        <div className="mb-3">
                            <Label htmlFor="confirmar_senha">Confirme a nova senha</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input
                                    type={confirmarSenhaShow ? "text" : "password"}
                                    id="confirmar_senha"
                                    name="confirmar_senha"
                                    placeholder="Confirme a nova senha"
                                    value={validation.values.confirmar_senha}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                    validation.touched.confirmar_senha &&
                                    !!validation.errors.confirmar_senha
                                    }
                                    disabled={loading}
                                />
                                <FormFeedback>{validation.errors.confirmar_senha}</FormFeedback>
                                <Button color="link" onClick={() => setConfirmarSenhaShow(!confirmarSenhaShow)} className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                id="password-addon"><i className="ri-eye-fill align-middle"></i></Button>
                            </div>                        
                        </div>
                    </Row>
                    
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={onClose} disabled={loading}>
                    Fechar
                    </Button>
                    <Button
                        color="success"
                        type="submit"
                        disabled={loading}
                        >
                        {loading ? "Salvando..." : "Salvar"}
                        </Button>

                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalAlterarSenha;
